import React from 'react';
import {toast} from 'react-toastify';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useAcceptInvite} from 'api/generated';
import {Transitioner, Button} from 'components';

import AcceptInviteWhoAreWe from './AcceptInvite.WhoAreWe';

interface IAcceptInviteJoinProps {
  invitor: string;
}

const AcceptInviteJoin = ({invitor}: IAcceptInviteJoinProps) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const navigate = useNavigate();

  const acceptInvite = useAcceptInvite();
  const handleAcceptInvite = async () => {
    const {data: res} = await acceptInvite.mutateAsync({params: {token}});
    if (res.data?.success) {
      navigate('/me/projects', {replace: true});
    } else if (res.data?.message) {
      toast.error(res.data.message);
    } else if (res.errors) {
      toast.error(res.errors[0].detail);
    }
  };

  return (
    <section className="flex flex-col flex-1 p-6 lg:px-8">
      <Transitioner>
        <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
          <h1 className="text-center text-2xl/9 font-bold dark:text-white">Join the project(s) on DasAR</h1>
          <p className="text-center dark:text-white mt-5">
            You were invited by <strong>{invitor}</strong>.
          </p>
        </div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col items-center mb-10">
          <Button text="Accept Invite" fullWidth size="small" onClick={handleAcceptInvite} loading={acceptInvite.isPending} />
        </div>
        <div className="flex justify-center py-10">
          <Transitioner delay={0.1}>
            <AcceptInviteWhoAreWe />
          </Transitioner>
        </div>
      </Transitioner>
    </section>
  );
};

export default React.memo(AcceptInviteJoin);
